"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorQueryParseSparql = void 0;
const bus_query_parse_1 = require("@comunica/bus-query-parse");
const context_entries_1 = require("@comunica/context-entries");
const core_1 = require("@comunica/core");
const algebra_sparql_1_2_1 = require("@traqula/algebra-sparql-1-2");
const parser_sparql_1_2_1 = require("@traqula/parser-sparql-1-2");
const rules_sparql_1_2_1 = require("@traqula/rules-sparql-1-2");
/**
 * A comunica Algebra SPARQL Parse Actor.
 */
class ActorQueryParseSparql extends bus_query_parse_1.ActorQueryParse {
    prefixes;
    parser;
    constructor(args) {
        super(args);
        this.prefixes = Object.freeze(args.prefixes);
        this.parser = new parser_sparql_1_2_1.Parser({ lexerConfig: {
                positionTracking: 'onlyOffset',
            } });
    }
    async test(action) {
        if (action.queryFormat && action.queryFormat.language !== 'sparql') {
            return (0, core_1.failTest)('This actor can only parse SPARQL queries');
        }
        return (0, core_1.passTestVoid)();
    }
    async run(action) {
        const dataFactory = action.context.getSafe(context_entries_1.KeysInitQuery.dataFactory);
        const astFactory = new rules_sparql_1_2_1.AstFactory();
        const parsedSyntax = this.parser.parse(action.query, {
            prefixes: this.prefixes,
            baseIRI: action.baseIRI,
            astFactory,
        });
        let baseIRI;
        if (astFactory.isQuery(parsedSyntax)) {
            for (const context of parsedSyntax.context) {
                if (astFactory.isContextDefinitionBase(context)) {
                    baseIRI = context.value.value;
                }
            }
        }
        return {
            baseIRI,
            operation: (0, algebra_sparql_1_2_1.toAlgebra)(parsedSyntax, {
                quads: true,
                prefixes: this.prefixes,
                blankToVariable: true,
                baseIRI: action.baseIRI,
                dataFactory,
            }),
        };
    }
}
exports.ActorQueryParseSparql = ActorQueryParseSparql;
//# sourceMappingURL=ActorQueryParseSparql.js.map